import React from 'react';

import {components, OptionProps} from 'react-select';
import styled from 'styled-components';

import {colors, font} from 'theme';

const Label = styled.div<{isSelected?: boolean}>`
    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    color: ${(p) => (p.isSelected ? colors.white : colors.textGrey1)};
    margin-bottom: 4px;
`;

export const StorageOption = (props: OptionProps<any, false>) => {
    const {data} = props;
    const itemData: {value: string; label: string} = {...data};
    return (
        <components.Option {...props}>
            <Label isSelected={props.isSelected}>{itemData.label}</Label>
        </components.Option>
    );
};
